export default __webpack_public_path__ + "static/media/flags-by-department.9f16f81c.svg";